import { generateAPI } from "../api.generator";
import { SupportTicket, TicketAttachment } from "../../types/ticket";
import { MessageReplyTo } from "../../types/feedback";

// POST /support-ticket/mine/:id/reply — reply within the customer's own ticket.
// Pass `params: `${ticketId}/reply`` + body. Returns the refreshed ticket.
export const replyToMyTicket = generateAPI<
  {
    params: string;
    body: {
      body: string;
      attachments?: TicketAttachment[];
      replyTo?: MessageReplyTo;
    };
  },
  SupportTicket
>("post", "support-ticket/mine");
